import lang from '@/lang'
const {
  bankingCancelPinRequestErrorMessage,
  bankingCancelTanRequestErrorMessage,
  bankingCancelTransactionErrorMessage,
} = lang

export class BankingTransactionRequestError extends Error {
  constructor(transaction) {
    super()
    this.message = 'Beim Verarbeiten der Transaktion ist ein Fehler aufgetreten.'
    this.name = 'BankingTransactionRequestError'
    this.transaction = transaction
  }
}

export class CancelPinRequestError extends BankingTransactionRequestError {
  constructor(props) {
    super(props)
    this.message = bankingCancelPinRequestErrorMessage
    this.name = 'CancelPinRequestError'
  }
}
export class CancelTanRequestError extends BankingTransactionRequestError {
  constructor(props) {
    super(props)
    this.message = bankingCancelTanRequestErrorMessage
    this.name = 'CancelTanRequestError'
  }
}

export class TransactionCanceled extends BankingTransactionRequestError {
  constructor(props) {
    super(props)
    this.message = bankingCancelTransactionErrorMessage
    this.name = 'TransactionCanceled'
  }
}
